import { useRouter } from 'next/router';
import { useAppSelector } from '@redux/hooks';
import { getAuthUserData } from '@entities/Auth';
import { useCallback } from 'react';
import { DefaultProps } from '@app/Types/global.interfaces';
import { useUserProfile } from '@app/entities/User';
import { SkeletonLoading } from '@app/shared';
import { IconProfile } from '@koleso-icons';
import classNames from 'classnames';

import styles from './ButtonProfileHeader.module.scss';

export enum ButtonProfile {
  Primary = 'primary',
  Short = 'short',
  MobileMenu = 'mobileMenu',
}

interface ButtonProfileHeaderProps extends DefaultProps {
  themes?: ButtonProfile;
}

export const ButtonProfileHeader = ({ className, themes }: ButtonProfileHeaderProps) => {
  const user = useAppSelector(getAuthUserData);
  const router = useRouter();
  const { profileTitle } = useUserProfile();

  const handlerClick = useCallback(async () => {
    user ? await router.push('/personal') : await router.push('/auth/login/');
  }, [user]);

  if (themes === ButtonProfile.Short) {
    return <ButtonProfileHeader.Short handlerClick={handlerClick} className={className} />;
  }

  if (user?.isLoggedin && !profileTitle) {
    return <ButtonProfileHeader.Skeleton />;
  }

  return (
    <button onClick={handlerClick} className={classNames(styles.ButtonProfile, className)} data-testid="header-btn-profile">
      <IconProfile width={13} height={15} />
      {profileTitle}
    </button>
  );
};

ButtonProfileHeader.Short = function Short({ handlerClick, className }) {
  return (
    <div className={classNames(styles.ShortProfile, className)} onClick={handlerClick}>
      <IconProfile width={13} height={15} />
    </div>
  );
};

ButtonProfileHeader.Skeleton = function Skeleton() {
  return (
    <div className={styles.ButtonProfile}>
      <SkeletonLoading width={'100px'} height={'20px'} />
    </div>
  );
};
